export default __webpack_public_path__ + "static/media/vinmonopolet-mobile.5b9f1928.png";